export default {
  creatingUser: false,
  createUserSubmitted: false,
  newUserId: false,

  pristine: true, // false if user has entered a query
  currentQuery: {},
  searchingUsers: false,

  currentUserId: null,

  // all user data responses get merged into the current user profile object:
  currentUser: {},

  selectedUsers: {},

  tableColumns: [],
  tableColumnsInProgress: [],
  isVisibleColumnsModalOpen: false,

  // track each request's loading and failure states:

  loadingUserProfile: false,
  failedUserProfile: null,

  loadingStartsCompletes: false,
  failedStartsCompletes: null,

  loadingRaffleEntries: false,
  failedRaffleEntries: null,

  loadingPrizeboothOrders: false,
  failedPrizeboothOrders: null,

  loadingPointHistory: false,
  failedPointHistory: null,

  // user-level actions:

  awardingPoints: false,
  awardPointsSubmitted: false,
  awardPointsError: null,

  awardingSpins: false,
  awardSpinsSubmitted: false,

  awardingDays: false,
  awardDaysSubmitted: false,

  changingPassword: false,
  changePasswordSubmitted: false,

  repairingProfile: false,
  repairProfileSubmitted: false,

  revokingAmountOfPoints: false,
  revokingAmountOfPointsSubmitted: false,

  revokingPoints: false,
  currentRevocation: null,
  revocationSubmitted: false,
  revokePointsSubmitted: false,

  confirmUserDataDeletion: false,
  userToDeleteData: null
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/initialState.js